
import { ElUpload } from 'element-plus'
import { defineComponent, ref, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
      default: ''
    },
    prop: {
      type: String,
      required: true,
      default: ''
    },
    fileName: {
      type: String,
      required: false,
      default: ''
    },
    action: {
      type: String,
      required: true,
      default: ''
    },
    headers: {
      type: Object,
      required: true,
      default: null
    },
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['download', 'upload', 'change'],
  setup(props, context) {
    const { t } = useI18n()
    const upload = ref(ElUpload)
    const errorItem = ref('')
    const selectFileName = ref(props.fileName)
    const handleDownload = () => {
      context.emit('download')
    }
    const validateUpload = (hideError: Boolean = false) => {
      if (selectFileName.value === null || selectFileName.value === '' || selectFileName.value === undefined) {
        if (!hideError) {
          errorItem.value = props.label.concat(t('common.isRequired'))
        }
        return true
      } else {
        errorItem.value = ''
      }
      return false
    }
    const submitUpload = () => {
      (upload.value as typeof ElUpload).submit()
    }
    const onSuccess = (response: any) => {
      context.emit('upload', response)
    }
    const onError = (err: any) => {
      context.emit('upload', err)
    }
    const onReset = () => {
      (upload.value as typeof ElUpload).clearFiles()
      errorItem.value = ''
      selectFileName.value = ''
    }
    const onChange = (file: any) => {
      selectFileName.value = file.name
      if (selectFileName.value !== null && selectFileName.value !== '' && selectFileName.value !== undefined) {
        errorItem.value = ''
      }
      context.emit('change', file)
    }
    watch(() => props.fileName, (fileName) => {
      (upload.value as typeof ElUpload).clearFiles()
      nextTick(function() {
        selectFileName.value = fileName
      })
    })
    return {
      t,
      upload,
      errorItem,
      handleDownload,
      onSuccess,
      onError,
      onReset,
      onChange,
      selectFileName,
      submitUpload,
      validateUpload
    }
  }
})
